import React from 'react';
import { useTranslation } from 'react-i18next';

const baseAssetsUrl = process.env.REACT_APP_BASE_ASSETS_URL;

const renderSortArrows = () => (
  <div className="up-down-arrow-btn">
    <img
      className="up-down-arrow-img up-down-arrow-img-forward active"
      src={`${baseAssetsUrl}images/icons/up-down-arrow.png`}
      alt=""
    />
    <img
      className="up-down-arrow-img up-down-arrow-img-reverse"
      src={`${baseAssetsUrl}images/icons/up-down-arrow-reverse.png`}
      alt=""
    />
  </div>
);

export default function ZoneIndexTableHead({
  selectAllStatus,
  setSelectAllStatus,
}) {
  const { t } = useTranslation();

  const handleSelectAllCheckBox = (event) => {
    const checkBox = event.target;
    const childCheckClass = `.${checkBox.getAttribute('data-select').replace('_main', '')}`;
    const allCheckbox = document.querySelectorAll(childCheckClass);

    if (checkBox.checked) {
      allCheckbox.forEach((checkBoxSelectable) => {
        checkBoxSelectable.checked = true;
      });
      setSelectAllStatus?.(true);
    } else {
      allCheckbox.forEach((checkBoxSelectable) => {
        checkBoxSelectable.checked = false;
      });
      setSelectAllStatus?.(false);
    }
  };

  const renderHeaderCell = (label, className = '', sortable = false) => (
    <th
      key={label || className || 'action'}
      className={`zone-index__th${className ? ` ${className}` : ''}${
        sortable ? ' zone-index__th--sortable sorting' : ''
      }`}
    >
      {label ? t(label) : null}
      {sortable ? renderSortArrows() : null}
    </th>
  );

  return (
    <thead>
      <tr>
        <th className="zone-index__th zone-index__th--check">
          <div className="com-check zone-index__check">
            <input
              checked={selectAllStatus}
              id="zone_index_select_all"
              onClick={handleSelectAllCheckBox}
              className="zoneListCheckBox_main"
              data-select="zoneListCheckBox_main"
              type="checkbox"
            />
            <label htmlFor="zone_index_select_all" className="com-check-label" />
          </div>
        </th>
        {renderHeaderCell('Ref No.', 'zone-index__th--ref')}
        {renderHeaderCell('Location', 'zone-index__th--location', true)}
        {renderHeaderCell('Zone', 'zone-index__th--zone', true)}
        {renderHeaderCell('Sale Person', 'zone-index__th--sale-person', true)}
        {renderHeaderCell('SKU', 'zone-index__th--sku', true)}
        {renderHeaderCell('Issue Date', 'zone-index__th--date', true)}
        {renderHeaderCell('Return Date', 'zone-index__th--date', true)}
        {renderHeaderCell('Issue', 'zone-index__th--issue')}
        {renderHeaderCell('Sold', 'zone-index__th--sold')}
        {renderHeaderCell('Return', 'zone-index__th--return')}
        {renderHeaderCell('Balance', 'zone-index__th--balance')}
        {renderHeaderCell('Status', 'zone-index__th--status')}
        {renderHeaderCell('User', 'zone-index__th--user')}
        <th className="zone-index__th zone-index__th--action" aria-label={t('Export')} />
      </tr>
    </thead>
  );
}
